var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6845 2.50903C5.9243 2.50903 2.06097 6.37236 2.06097 11.1325C2.06097 15.8927 5.9243 19.756 10.6845 19.756C15.4446 19.756 19.308 15.8927 19.308 11.1325C19.308 6.37236 15.4446 2.50903 10.6845 2.50903ZM8.34749 14.8323L5.25165 11.7364C4.91533 11.4001 4.91533 10.8568 5.25165 10.5205C5.58797 10.1842 6.13125 10.1842 6.46756 10.5205L8.95975 13.0041L14.8927 7.07113C15.229 6.73481 15.7723 6.73481 16.1086 7.07113C16.4449 7.40744 16.4449 7.95072 16.1086 8.28704L9.5634 14.8323C9.2357 15.1686 8.6838 15.1686 8.34749 14.8323Z",
    fill: "#0CF18A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVMark);
export default __webpack_public_path__ + "static/media/vMark.7b28433e7c41969dafdd211c3645e205.svg";
export { ForwardRef as ReactComponent };